<template>
  <div class="brand-logo-slider-area pt-0 section-space--inner--60">
    <div class="search">
      <div class="input-group mt-3 mb-3">
        <div class="input-group-prepend">
          <select
            @change="resetFilter"
            v-model="filter_pencarian"
            name="cars"
            class="custom-select"
          >
            <option value="" selected>Pencarian</option>
            <option value="cari_barang">Cari Barang</option>
          </select>
        </div>
        <input
          type="text"
          class="form-control"
          v-model="input_pencarian"
          placeholder="Ketik nama barang/produk.."
        />
        <div class="input-group-append">
          <button class="btn btn-blue" type="submit">
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
    <template v-if="filter_pencarian == ``">
      <div class="section-kategori">
        <Kategori />
      </div>
      <div class="section-terpopuler">
        <Terpopuler />
      </div>
      <div class="section-produk-terbaru">
        <ProdukTerbaru />
      </div>
      <div class="section-penjualan-terlaris">
        <PenjualanTerlaris />
      </div>

      <div class="section-daftar-penjual">
        <DaftarPenjual />
      </div>

      <div class="section-toko-sekolah">
        <TokoSekolah />
      </div>
    </template>
    <template v-if="filter_pencarian == `cari_barang`">
      <div class="section-pencarian-barang">
        <PencarianBarang :input_pencarian="input_pencarian" />
      </div>
    </template>
    <template v-if="filter_pencarian == `cari_penjual`">
      <div>Penjual</div>
    </template>
  </div>
</template>
<script>
import Kategori from "./Kategori";
import Terpopuler from "./Terpopuler";
import ProdukTerbaru from "./ProdukTerbaru";
import PenjualanTerlaris from "./PenjualanTerlaris";
import TokoSekolah from "./TokoSekolah";
import DaftarPenjual from "./DaftarPenjual";
import PencarianBarang from "./PencarianBarang";

export default {
  name: "KewirausahaanWrapper",
  components: {
    Kategori,
    Terpopuler,
    ProdukTerbaru,
    PenjualanTerlaris,
    TokoSekolah,
    DaftarPenjual,
    PencarianBarang,
  },
  data() {
    return {
      filter_pencarian: "",
      input_pencarian: "",
    };
  },
  methods: {
    resetFilter() {
      console.log(`filter`, this.filter_pencarian);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_kewirausahaan_template_1.scss";
.center-block {
  display: table; /* Instead of display:block */
  margin-left: auto;
  margin-right: auto;
}

.search {
  width: 100% !important;
  padding: 10px 100px 10px 100px;
}
</style>
